import React from "react";
import { formatPrice, to12HourTime } from "../../../utils";
import { BookingEventWithPrice } from "../../../models/booking/BookingEventWithPrice";

interface ServiceCardProps {
  event: BookingEventWithPrice;
  bookingDate: Date | null | undefined;
  chargeAmount: number;
  chargeLabel: string;
  sectionType: 'charge' | 'hold' | 'none';
  isAnyProvider?: boolean;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({
  event,
  bookingDate,
  chargeAmount,
  chargeLabel,
  sectionType,
  isAnyProvider,
}) => {
  const servicePrice = event.effectivePrice; 
  const eventDate = event.date || bookingDate || null;
  
  return (
    <div className="mb-2">
      {/* Service Info Row */}
      <div className="d-flex justify-content-between align-items-start mb-2">
        <div className="flex-grow-1">
          <p className="mb-0 fw-semibold fs-6">{event.service?.name}</p>
          {(event.provider?.name || isAnyProvider) && (
            <p className="mb-0 text-muted small">with {event.provider?.name ?? 'Any Provider'}</p>
          )}
          {eventDate && (
            <p className="mb-0 text-muted small">
              {eventDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
              {event.startTime && ` at ${to12HourTime(event.startTime)}`}
            </p>
          )}
        </div>
        {chargeAmount > 0 && (
          <div className="text-end ms-3">
            <p className="mb-0 text-muted small">{chargeLabel}</p>
            <p className="mb-0 fw-normal">{formatPrice(chargeAmount)}</p>
          </div>
        )}
      </div>
    </div>
  );
};